import React, { useEffect, useState } from "react";
import axios from 'axios';
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button, Card, CardBody, CardHeader, Col, Form, FormFeedback, FormGroup, Input, Label, Row } from "reactstrap";
import Select from "react-select";
import { modelEmpWorkExp } from "./model_employee";
import ConfigData from '../../config.json';
import { handlerRespError } from "../utility/handler_resp";
import { useHistory } from "react-router-dom";

const EmployeeWork = ({dataGeneral, dataWorkInfo, dataWorkExp, idEmpGeneral, onSave, onCancel}) => {
    const [generals, setGenerals] = useState(dataGeneral);
    const [workInfos, setWorkInfos] = useState(dataWorkInfo);
    const [workExps, setWorkExps] = useState(dataWorkExp);
    const [selectBusinessUnit, setSelectBusinessUnit] = useState(null);
    const [ddlBusinessUnit, setDdlBusinessUnit] = useState([]);
    const [selectDepartment, setSelectDepartment] = useState(null);
    const [ddlDepartment, setDdlDepartment] = useState([]);
    const [selectSubDepartment, setSelectSubDepartment] = useState(null);
    const [ddlSubDepartment, setDdlSubDepartment] = useState([]);
    const [selectDivision, setSelectDivision] = useState(null);
    const [ddlDivision, setDdlDivision] = useState([]);
    const [selectSubDivision, setSelectSubDivision] = useState(null);
    const [ddlSubDivision, setDdlSubDivision] = useState([]);
    const [selectSection, setSelectSection] = useState(null);
    const [ddlSection, setDdlSection] = useState([]);
    const [selectSubSection, setSelectSubSection] = useState(null);
    const [ddlSubSection, setDdlSubSection] = useState([]);
    const [selectCostCenter, setSelectCostCenter] = useState(null);
    const [ddlCostCenter, setDdlCostCenter] = useState([]);
    const [selectSupervisor, setSelectSupervisor] = useState(null);
    const [ddlSupervisor, setDdlSupervisor] = useState([]);
    const [selectOneOverOne, setSelectOneOverOne] = useState(null);
    const [ddlOneOverOne, setDdlOneOverOne] = useState([]);
    const [selectHOD, setSelectHOD] = useState(null);
    const [ddlHOD, setDdlHOD] = useState([]);
    const [selectMentor, setSelectMentor] = useState(null);
    const [ddlMentor, setDdlMentor] = useState([]);
    const [selectPosition, setSelectPosition] = useState(null);
    const [ddlPosition, setDdlPosition] = useState([]);
    const [dataPosition, setDataPosition] = useState([]);
    const [selectLevelPosition, setSelectLevelPosition] = useState(null);
    const [ddlLevelPosition, setDdlLevelPosition] = useState([]);
    const [selectEmploymentType, setSelectEmploymentType] = useState(null);
    const [ddlEmploymentType, setDdlEmploymentType] = useState([]);
    const history = useHistory();
    let indexWorkExp = 0;

    useEffect(() => {
        LoadDataBusinessUnit();
        LoadDataDepartment();
        LoadDataSubDepartment();
        LoadDataDivision();
        LoadDataSubDivision();
        LoadDataSection();
        LoadDataSubSection();
        LoadDataCostCenter();
        LoadDataEmployees();
        LoadDataPosition();
        LoadDataLevelPosition();
        LoadDataEmploymentType();
    }, []);

    useEffect(() => {
        setGenerals(dataGeneral);
        setWorkInfos(dataWorkInfo);
        setWorkExps(dataWorkExp);
    }, [dataGeneral, dataWorkInfo, dataWorkExp]);

    useEffect(() => {
        setSelectBusinessUnit(ddlBusinessUnit.find(x => x.value === dataWorkInfo.id_business_unit.toString()));
        setSelectDepartment(ddlDepartment.find(x => x.value === dataWorkInfo.id_department.toString()));
        setSelectSubDepartment(ddlSubDepartment.find(x => x.value === dataWorkInfo.id_sub_department.toString()));
        setSelectDivision(ddlDivision.find(x => x.value === dataWorkInfo.id_division.toString()));
        setSelectSubDivision(ddlSubDivision.find(x => x.value === dataWorkInfo.id_sub_division.toString()));
        setSelectSection(ddlSection.find(x => x.value === dataWorkInfo.id_section.toString()));
        setSelectSubSection(ddlSubSection.find(x => x.value === dataWorkInfo.id_sub_section.toString()));
        setSelectPosition(dataPosition.find(x => x.value === dataWorkInfo.id_position.toString()));
        setSelectLevelPosition(ddlLevelPosition.find(x => x.value === dataWorkInfo.id_level_position.toString()));
        setSelectEmploymentType(ddlEmploymentType.find(x => x.value === dataWorkInfo.id_employment_type.toString()));
        setSelectCostCenter(ddlCostCenter.find(x => x.value === dataWorkInfo.id_cost_center.toString()));
        setSelectSupervisor(ddlSupervisor.find(x => x.value === dataWorkInfo.supervisor.toString()));
        setSelectOneOverOne(ddlOneOverOne.find(x => x.value === dataWorkInfo.one_over_one.toString()));
        setSelectHOD(ddlHOD.find(x => x.value === dataWorkInfo.hod_id.toString()));
        setSelectMentor(ddlMentor.find(x => x.value === dataWorkInfo.mentor_id.toString()));
    }, [dataWorkInfo, ddlBusinessUnit, ddlDepartment, ddlSubDepartment, ddlDivision, ddlSubDivision, ddlSection, ddlSubSection, dataPosition, ddlEmploymentType, ddlCostCenter, ddlSupervisor, ddlOneOverOne, ddlHOD, ddlMentor]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            general: generals,
            work_info: workInfos,
            work_exp: workExps,
        },
        validationSchema: Yup.object({
            work_info: Yup.object().shape({
                id_business_unit: Yup.string().required("Please select a Business unit"),
                id_department: Yup.string().required("Please select a Department"),
                id_position: Yup.string().required("Please select a Position"),
                id_level_position: Yup.string().required("Please select a Level position"),
                id_employment_type: Yup.string().required("Please select a Employment type"),
                email: Yup.string().required("Please enter a Office email"),
                join_date: Yup.string().required("Please enter a Join date"),
            }),
            work_exp: Yup.array().of(
                Yup.object().shape({
                    company_name: Yup.string().required("Please enter a Company name"),
                    begin_date: Yup.string().required("Please enter a Start date"),
                    finish_date: Yup.string().required("Please enter a End date"),
                })
            ),
        }),
        onSubmit: onSave
    });

    const onClickAddWorkExp = () => {
        const arrWorkExp = [...validation.values.work_exp];
        arrWorkExp.push(modelEmpWorkExp);
        setUpdateDataOnEvent(null, arrWorkExp);
    };

    const onClickDeleteWorkExp = (index) => {
        const arrWorkExp = [...validation.values.work_exp];
        let objWorkExp = {...arrWorkExp[index]};
        objWorkExp.status = "0";
        objWorkExp.company_name = "-";
        objWorkExp.begin_date = "-";
        objWorkExp.finish_date = "-";
        arrWorkExp[index] = objWorkExp;
        validation.handleChange("work_exp." + index + ".status")("0");
        validation.handleChange("work_exp." + index + ".company_name")("-");
        validation.handleChange("work_exp." + index + ".begin_date")("-");
        validation.handleChange("work_exp." + index + ".finish_date")("-");
        setUpdateDataOnEvent(null, arrWorkExp);
    };

    const setUpdateDataOnEvent = (dWorkInfo, dWorkExp) => {
        if(dWorkInfo === null){
            dWorkInfo = {...validation.values.work_info};
        }
        if(dWorkExp === null){
            dWorkExp = [...validation.values.work_exp];
        }
        setWorkInfos(dWorkInfo);
        setWorkExps(dWorkExp);
    };

    const LoadDataBusinessUnit = () => {
        let url = ConfigData.API_URL + "business-unit/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                    };
                });
                setDdlBusinessUnit(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataDepartment = () => {
        let url = ConfigData.API_URL + "department/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                    };
                });
                setDdlDepartment(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataSubDepartment = () => {
        let url = ConfigData.API_URL + "sub-department/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                        id_department: e.id_department.toString(),
                    };
                });
                setDdlSubDepartment(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataDivision = () => {
        let url = ConfigData.API_URL + "division/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                        id_department: e.id_department.toString(),
                        id_sub_department: e.id_sub_department.toString(),
                    };
                });
                setDdlDivision(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataSubDivision = () => {
        let url = ConfigData.API_URL + "sub-division/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                        id_department: e.id_department.toString(),
                        id_sub_department: e.id_sub_department.toString(),
                        id_division: e.id_division.toString(),
                    };
                });
                setDdlSubDivision(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataSection = () => {
        let url = ConfigData.API_URL + "section/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                        id_department: e.id_department.toString(),
                        id_sub_department: e.id_sub_department.toString(),
                        id_division: e.id_division.toString(),
                        id_sub_division: e.id_sub_division.toString(),
                    };
                });
                setDdlSection(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataSubSection = () => {
        let url = ConfigData.API_URL + "sub-section/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                        id_department: e.id_department.toString(),
                        id_sub_department: e.id_sub_department.toString(),
                        id_division: e.id_division.toString(),
                        id_sub_division: e.id_sub_division.toString(),
                        id_section: e.id_section.toString(),
                    };
                });
                setDdlSubSection(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataCostCenter = () => {
        let url = ConfigData.API_URL + "cost-center/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                    };
                });
                setDdlCostCenter(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataEmployees = () => {
        let url = ConfigData.API_URL + "employee-general/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        // label: e.name_th + " " + e.surname_th,
                        label: e.name_en + " " + e.surname_en,
                        value: e.id.toString(),
                    };
                });
                setDdlSupervisor(arrData);
                setDdlOneOverOne(arrData);
                setDdlHOD(arrData);
                setDdlMentor(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataPosition = () => {
        let url = ConfigData.API_URL + "position/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                        id_department: e.id_department.toString(),
                    };
                });
                // setDdlPosition(arrData);
                setDataPosition(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataLevelPosition = () => {
        let url = ConfigData.API_URL + "level-position/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                    };
                });
                setDdlLevelPosition(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataEmploymentType = () => {
        let url = ConfigData.API_URL + "employment-type/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                    };
                });
                setDdlEmploymentType(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    return(
        <React.Fragment>
            <Form className="needs-validation"
                onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                }}
            >
                {/* Company Information */}
                <Row>
                    <Col xl={12}>
                        <Card>
                            <CardHeader>
                                <h6 className="card-title mb-0">Company Information</h6>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="ddlWorkInfoBusinessUnit">Business Unit</Label>
                                            <Select id="ddlWorkInfoBusinessUnit"
                                                name="work_info.id_business_unit"
                                                value={selectBusinessUnit}
                                                onChange={(selected) => {
                                                    setSelectBusinessUnit(selected);
                                                    validation.handleChange('work_info.id_business_unit')((selected !== null) ? selected.value : "");
                                                }}
                                                options={ddlBusinessUnit}
                                                isClearable={true}
                                                isSearchable={true}
                                                invalid={ validation.errors.work_info?.id_business_unit ? true : false }
                                            />
                                            { validation.errors.work_info?.id_business_unit ? 
                                                ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.work_info?.id_business_unit}</FormFeedback> ) : false 
                                            }
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="ddlWorkInfoDepartment">Department</Label>
                                            <Select id="ddlWorkInfoDepartment"
                                                name="work_info.id_department"
                                                value={selectDepartment}
                                                onChange={(selected) => {
                                                    let id_department = (selected !== null) ? selected.value : "";
                                                    setDdlPosition(dataPosition.filter((e) => e.id_department === id_department));
                                                    setSelectDepartment(selected);
                                                    setSelectPosition(null);
                                                    validation.handleChange('work_info.id_department')((selected !== null) ? selected.value : "");
                                                    validation.handleChange('work_info.id_position')("");
                                                }}
                                                options={ddlDepartment}
                                                isClearable={true}
                                                isSearchable={true}
                                                invalid={ validation.errors.work_info?.id_department ? true : false }
                                            />
                                            { validation.errors.work_info?.id_department ? 
                                                ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.work_info?.id_department}</FormFeedback> ) : false 
                                            }
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="ddlWorkInfoSubDepartment">Sub department</Label>
                                            <Select id="ddlWorkInfoSubDepartment"
                                                name="work_info.id_sub_department"
                                                value={selectSubDepartment}
                                                onChange={(selected) => {
                                                    setSelectSubDepartment(selected);
                                                    validation.handleChange('work_info.id_sub_department')((selected !== null) ? selected.value : "");
                                                }}
                                                options={ddlSubDepartment}
                                                isClearable={true}
                                                isSearchable={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="ddlWorkInfoDivision">Division</Label>
                                            <Select id="ddlWorkInfoDivision"
                                                name="work_info.id_division"
                                                value={selectDivision}
                                                onChange={(selected) => {
                                                    setSelectDivision(selected);
                                                    validation.handleChange('work_info.id_division')((selected !== null) ? selected.value : "");
                                                }}
                                                options={ddlDivision}
                                                isClearable={true}
                                                isSearchable={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="ddlWorkInfoSubDivision">Sub division</Label>
                                            <Select id="ddlWorkInfoSubDivision"
                                                name="work_info.id_sub_division"
                                                value={selectSubDivision}
                                                onChange={(selected) => {
                                                    setSelectSubDivision(selected);
                                                    validation.handleChange('work_info.id_sub_division')((selected !== null) ? selected.value : "");
                                                }}
                                                options={ddlSubDivision}
                                                isClearable={true}
                                                isSearchable={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="ddlWorkInfoSection">Section</Label>
                                            <Select id="ddlWorkInfoSection"
                                                name="work_info.id_section"
                                                value={selectSection}
                                                onChange={(selected) => {
                                                    setSelectSection(selected);
                                                    validation.handleChange('work_info.id_section')((selected !== null) ? selected.value : "");
                                                }}
                                                options={ddlSection}
                                                isClearable={true}
                                                isSearchable={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="ddlWorkInfoSubSection">Sub section</Label>
                                            <Select id="ddlWorkInfoSubSection"
                                                name="work_info.id_sub_section"
                                                value={selectSubSection}
                                                onChange={(selected) => {
                                                    setSelectSubSection(selected);
                                                    validation.handleChange('work_info.id_sub_section')((selected !== null) ? selected.value : "");
                                                }}
                                                options={ddlSubSection}
                                                isClearable={true}
                                                isSearchable={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="ddlWorkInfoCostCenter">Cost center</Label>
                                            <Select id="ddlWorkInfoCostCenter"
                                                name="work_info.id_cost_center"
                                                value={selectCostCenter}
                                                onChange={(selected) => {
                                                    setSelectCostCenter(selected);
                                                    validation.handleChange('work_info.id_cost_center')((selected !== null) ? selected.value : "");
                                                }}
                                                options={ddlCostCenter}
                                                isClearable={true}
                                                isSearchable={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="ddlWorkInfoSupervisor">Supervisor Emp</Label>
                                            <Select id="ddlWorkInfoSupervisor"
                                                name="work_info.supervisor"
                                                value={selectSupervisor}
                                                onChange={(selected) => {
                                                    setSelectSupervisor(selected);
                                                    validation.handleChange('work_info.supervisor')((selected !== null) ? selected.value : "");
                                                }}
                                                options={ddlSupervisor}
                                                isClearable={true}
                                                isSearchable={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="ddlWorkInfoOneOverOne">One over one Emp</Label>
                                            <Select id="ddlWorkInfoOneOverOne"
                                                name="work_info.one_over_one"
                                                value={selectOneOverOne}
                                                onChange={(selected) => {
                                                    setSelectOneOverOne(selected);
                                                    validation.handleChange('work_info.one_over_one')((selected !== null) ? selected.value : "");
                                                }}
                                                options={ddlOneOverOne}
                                                isClearable={true}
                                                isSearchable={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="ddlWorkInfoHOD">HOD</Label>
                                            <Select id="ddlWorkInfoHOD"
                                                name="work_info.hod_id"
                                                value={selectHOD}
                                                onChange={(selected) => {
                                                    setSelectHOD(selected);
                                                    validation.handleChange('work_info.hod_id')((selected !== null) ? selected.value : "");
                                                }}
                                                options={ddlHOD}
                                                isClearable={true}
                                                isSearchable={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="ddlWorkInfoMentor">Mentor</Label>
                                            <Select id="ddlWorkInfoMentor"
                                                name="work_info.mentor_id"
                                                value={selectMentor}
                                                onChange={(selected) => {
                                                    setSelectMentor(selected);
                                                    validation.handleChange('work_info.mentor_id')((selected !== null) ? selected.value : "");
                                                }}
                                                options={ddlMentor}
                                                isClearable={true}
                                                isSearchable={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                {/* Current work info */}
                <Row>
                    <Col xl={12}>
                        <Card>
                            <CardHeader>
                                <h6 className="card-title mb-0">Current work info</h6>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="ddlWorkInfoPosition">Position</Label>
                                            <Select id="ddlWorkInfoPosition"
                                                name="work_info.id_position"
                                                value={selectPosition}
                                                onChange={(selected) => {
                                                    setSelectPosition(selected);
                                                    validation.handleChange('work_info.id_position')((selected !== null) ? selected.value : "");
                                                }}
                                                options={ddlPosition}
                                                isClearable={true}
                                                isSearchable={true}
                                                invalid={ validation.errors.work_info?.id_position ? true : false }
                                            />
                                            { validation.errors.work_info?.id_position ? 
                                                ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.work_info?.id_position}</FormFeedback> ) : false 
                                            }
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="ddlWorkInfoLevelPosition">Level position</Label>
                                            <Select id="ddlWorkInfoLevelPosition"
                                                name="work_info.id_level_position"
                                                value={selectLevelPosition}
                                                onChange={(selected) => {
                                                    setSelectLevelPosition(selected);
                                                    validation.handleChange('work_info.id_level_position')((selected !== null) ? selected.value : "");
                                                }}
                                                options={ddlLevelPosition}
                                                isClearable={true}
                                                isSearchable={true}
                                                invalid={ validation.errors.work_info?.id_level_position ? true : false }
                                            />
                                            { validation.errors.work_info?.id_level_position ? 
                                                ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.work_info?.id_level_position}</FormFeedback> ) : false 
                                            }
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="ddlWorkInfoEmploymentType">Type of employment</Label>
                                            <Select id="ddlWorkInfoEmploymentType"
                                                name="work_info.id_employment_type"
                                                value={selectEmploymentType}
                                                onChange={(selected) => {
                                                    setSelectEmploymentType(selected);
                                                    validation.handleChange('work_info.id_employment_type')((selected !== null) ? selected.value : "");
                                                }}
                                                options={ddlEmploymentType}
                                                isClearable={true}
                                                isSearchable={true}
                                                invalid={ validation.errors.work_info?.id_employment_type ? true : false }
                                            />
                                            { validation.errors.work_info?.id_employment_type ? 
                                                ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.work_info?.id_employment_type}</FormFeedback> ) : false 
                                            }
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="txtWorkInfoJoinDate">Join date</Label>
                                            <Input id="txtWorkInfoJoinDate" 
                                                name="work_info.join_date"
                                                placeholder="Join date"
                                                type="date"
                                                className="from-control"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.work_info.join_date || ""}
                                                invalid={ validation.errors.work_info?.join_date ? true : false }
                                            />
                                            { validation.errors.work_info?.join_date ? 
                                                ( <FormFeedback type="invalid">{validation.errors.work_info?.join_date}</FormFeedback> ) : false 
                                            }
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="txtWorkInfoProbationEndDate">Probation ended date</Label>
                                            <Input id="txtWorkInfoProbationEndDate" 
                                                name="work_info.probation_end_date"
                                                placeholder="Probation ended date"
                                                type="date"
                                                className="from-control"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.work_info.probation_end_date || ""}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="txtWorkInfoOfficeEmail">Office email</Label>
                                            <Input id="txtWorkInfoOfficeEmail" 
                                                name="work_info.email"
                                                placeholder="Office email"
                                                type="text"
                                                className="from-control"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.work_info.email || ""}
                                                invalid={ validation.errors.work_info?.email ? true : false }
                                            />
                                            { validation.errors.work_info?.email ? 
                                                ( <FormFeedback type="invalid">{validation.errors.work_info?.email}</FormFeedback> ) : false 
                                            }
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="txtWorkInfoOfficePhone">Office phone</Label>
                                            <Input id="txtWorkInfoOfficePhone" 
                                                name="work_info.office_phone"
                                                placeholder="Office phone"
                                                type="text"
                                                className="from-control"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.work_info.office_phone || ""}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="txtWorkInfoWorkLocation">Work location</Label>
                                            <Input id="txtWorkInfoWorkLocation" 
                                                name="work_info.work_location"
                                                placeholder="Work location"
                                                type="text"
                                                className="from-control"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.work_info.work_location || ""}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                {/* Work experience */}
                <Row>
                    <Col xl={12}>
                        <Card>
                            <CardHeader>
                                <h6 className="card-title mb-0">Work experience</h6>
                            </CardHeader>
                            <CardBody>
                                {workExps.map((valWE, keyWE) => {
                                    if(valWE.status === "1"){
                                        const workExpErrors = validation.errors.work_exp?.length && validation.errors.work_exp[keyWE] || {};
                                        indexWorkExp += 1;
                                        return(
                                            <div key={"divWorkExp" + keyWE}>
                                                <Row className={"pt-2 " + ((indexWorkExp > 1) ? "border-top" : "")}>
                                                    <Col md={12}>
                                                        <h6 className="d-inline">{indexWorkExp}.</h6>
                                                        <Button type="button" color="danger" className="btn-icon float-end" 
                                                            onClick={() => { 
                                                                onClickDeleteWorkExp(keyWE); 
                                                            }}
                                                        >
                                                            <i className="ri-delete-bin-5-line" />
                                                        </Button>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={12}>
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor={"txtWorkExpCompanyName" + keyWE} >Company name</Label>
                                                            <Input id={"txtWorkExpCompanyName" + keyWE} 
                                                                name={"work_exp." + keyWE + ".company_name"}
                                                                placeholder="Company name"
                                                                type="text"
                                                                className="from-control"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.work_exp[keyWE]?.company_name || ""}
                                                                invalid={ workExpErrors.company_name ? true : false }
                                                            />
                                                            { workExpErrors.name ? 
                                                                ( <FormFeedback type="invalid">{workExpErrors.company_name}</FormFeedback> ) : false 
                                                            }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={6}>
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor={"txtWorkExpBeginDate" + keyWE}>Start date</Label>
                                                            <Input id={"txtWorkExpBeginDate" + keyWE}
                                                                name={"work_exp." + keyWE + ".begin_date"}
                                                                placeholder="Start date"
                                                                type="date"
                                                                className="from-control"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.work_exp[keyWE]?.begin_date || ""}
                                                                invalid={ workExpErrors.begin_date ? true : false }
                                                            />
                                                            { workExpErrors.begin_date ? 
                                                                ( <FormFeedback type="invalid">{workExpErrors.begin_date}</FormFeedback> ) : false 
                                                            }
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={6}>
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor={"txtWorkExpFinishDate" + keyWE}>End date</Label>
                                                            <Input id={"txtWorkExpFinishDate" + keyWE}
                                                                name={"work_exp." + keyWE + ".finish_date"}
                                                                placeholder="End date"
                                                                type="date"
                                                                className="from-control"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.work_exp[keyWE]?.finish_date || ""}
                                                                invalid={ workExpErrors.finish_date ? true : false }
                                                            />
                                                            { workExpErrors.finish_date ? 
                                                                ( <FormFeedback type="invalid">{workExpErrors.finish_date}</FormFeedback> ) : false 
                                                            }
                                                        </FormGroup>
                                                    </Col>      
                                                </Row>
                                                <Row>
                                                    <Col md={12}>
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor={"txtWorkExpWorkDetail" + keyWE} >Working detail</Label>
                                                            <Input id={"txtWorkExpWorkDetail" + keyWE} 
                                                                name={"work_exp." + keyWE + ".work_detail"}
                                                                placeholder="Work detail"
                                                                type="text"
                                                                className="from-control"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.work_exp[keyWE]?.work_detail || ""}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </div>
                                        );
                                    }
                                })}
                                <div className="justify-content-center d-flex">
                                    <Button color="primary" type="button" className="btn-rounded btn-icon"
                                        onClick={onClickAddWorkExp}
                                    >
                                        <i className="ri-add-line" />
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <div className="footer-div">
                    <div className="justify-content-center d-flex">
                        <Button color="primary" type="button" onClick={onCancel} >
                            Close
                        </Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Button color="success" type="submit">
                            Save
                        </Button>
                    </div>
                </div>
            </Form>
        </React.Fragment>
    );
};

export default EmployeeWork;